import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    rolesData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getAllRoles = createAsyncThunk(
    "usermanagement/roles",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            const { sortColumn, isAsce } = orderBy;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.getroles;
            const institution = user?.institution?.value

            const apiURL = base + endpointpath + institution + `/${pageSize}/${currentPage}/${sortColumn}/${isAsce}`;

            const response = await axiosInstance.post(apiURL, search);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddUpdateRole = createAsyncThunk(
    "usermanagement/addrole",
    async ({ user, body, update }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = update ? endpoint?.backoffice?.updaterole : endpoint?.backoffice?.addrole;

            const apiURL = base + endpointpath;

            const method = update ? 'put' : 'post';
            const response = await axiosInstance[method](apiURL, body);

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const rolesSlice = createSlice({
    name: "roles",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL USERS
            .addCase(getAllRoles.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllRoles.fulfilled, (state, action) => {
                const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.rolesData = resp || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages };
            })
            .addCase(getAllRoles.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.rolesData = [];
                state.pagination = null;
            })

            // ADD USER
            .addCase(postAddUpdateRole.pending, (state) => {
                state.error = null;
            })
            .addCase(postAddUpdateRole.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddUpdateRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default rolesSlice.reducer;